import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { IconoUtility } from '../../utilities/icono.utility';

import swal from 'sweetalert2';

declare var jQuery: any;

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
  errors: Array<string> = [];
  dragAreaClass: string = 'dragarea';
  @Input() fileExt: string = "JPG, GIF, PNG";
  @Input() maxFiles: number = 5;
  @Input() maxSize: number = 6; // 5MB
  @Output() filesUpload = new EventEmitter();

  formData: FormData;

  files: any[] = [];

  filesPreview: any[];

  filesSize: string;

  constructor() { }

  ngOnInit() {
    this.formData = new FormData();
    this.filesSize = '0.0 MB';
  }

  onFileChange(event) {
    let files = event.target.files;
    this.saveFiles(files);
  }

  @HostListener('dragover', ['$event']) onDragOver(event) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }

  @HostListener('dragenter', ['$event']) onDragEnter(event) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }

  @HostListener('dragend', ['$event']) onDragEnd(event) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener('drop', ['$event']) onDrop(event) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
    event.stopPropagation();
    var files = event.dataTransfer.files;
    this.saveFiles(files);
  }


  saveFiles(files) {
    this.errors = []; // Clear error
    // Validate file size and allowed extensions
    if (files.length > 0 && (!this.isValidFiles(files))) {
      return;
    }

    if (files.length > 0) {
      for (var j = 0; j < files.length; j++) {
        this.files.push(files[j]);
      }
      this.refreshPreview();
      this.eventEmitter();
    }
  }


  private isValidFiles(files) {
    // Check Number of files
    if (files.length > this.maxFiles) {
      this.errors.push("Error: En un momento puedes subir solo " + this.maxFiles + " archivos");
      return;
    }
    this.isValidFileExtension(files);
    return this.errors.length === 0;
  }

  private isValidFileExtension(files) {
    // Make array of file extensions
    var extensions = (this.fileExt.split(','))
      .map(function (x) { return x.toLocaleUpperCase().trim() });

    for (var i = 0; i < files.length; i++) {
      // Get file extension
      var ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
      // Check the extension exists
      var exists = extensions.includes(ext);
      if (!exists) {
        this.errors.push('Error (Extension): ' + files[i].name);
        swal({
          width: 400,
          title: 'Error Archivo ' + files[i].name,
          html: `<br/><p style="font-size:14px">El archivo que intenta subir tiene una extensión no válida. <br/><br/>Las extensiones permitidas son:<br/><b>${this.fileExt}</b></p>`,
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
      }
      // Check file size
      this.isValidFileSize(files[i]);
    }
  }


  private isValidFileSize(file) {

    var _size = this.sizeFiles();

    var _sizeTotal = _size + file.size;
    var fileSizeTotalinMB = _sizeTotal / (1024 * 1000);
    var fileSizeinMB = file.size / (1024 * 1000);
    var size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
    var sizeTotal = Math.round(fileSizeTotalinMB * 100) / 100;

    if (sizeTotal > this.maxSize) {
      this.errors.push("Error (Tamaño del archivo): " + file.name + "(" + size + "MB ): ha excedido el límite de cargue de " + this.maxSize + "MB permitido para esta solicitud");
    } else {
      this.filesSize = sizeTotal + ' MB'
    }


  }

  private sizeFiles(): number {

    var _size = 0;

    for (var i = 0; i < this.files.length; i++) {
      _size += this.files[i].size;
    }

    return _size;

  }

  refreshPreview() {
    this.filesPreview = [];
    var _files = this.files;

    for (let _f of _files) {
      let f = <File>_f;
      let _typeFile = IconoUtility.getNameIconoType(f.name);
      let _icono = '';

      if (_typeFile === 'imagen') {
        var reader = new FileReader();
        reader.onload = (e: any) => {
          this.filesPreview.push({ name: f.name, size: Math.ceil(f.size / 1024) + ' kB', icono: undefined, src: e.target.result });
        };
        reader.readAsDataURL(f);
      } else {
        _icono = _typeFile;
        this.filesPreview.push({ name: f.name, size: Math.ceil(f.size / 1024) + ' kB', icono: _icono, src: undefined });
      }

    }
  }

  eventEmitter() {
    this.filesUpload.emit(this.files);
  }

  removeFile(namefile: string) {

    var _files = this.files;

    for (var i = 0; i < _files.length; i++) {
      if (_files[i].name === namefile) {
        _files.splice(i, 1);
        var _size = this.sizeFiles();       
        var fileSizeTotalinMB = _size / (1024 * 1000);
        var sizeTotal = Math.round(fileSizeTotalinMB * 100) / 100;
        this.filesSize = sizeTotal + ' MB';          
        break;
      }
    }

    this.refreshPreview();
    this.eventEmitter();

  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/file-upload/file-upload.component.ts